import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const eventImporterSelectors = importerSelectors(
  'event.importer',
);

export default eventImporterSelectors;
